export default __webpack_public_path__ + "static/media/chest-logo-gray-400.d44cd26d.svg";